import React from "react";
import {
  Box,
  VStack,
  Text,
  IconButton,
  Flex,
  Badge,
  Button,
} from "@chakra-ui/react";
import { MdClose, MdDeleteForever } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { BroadcastSupplier } from "./utils/broadcastUtils";

interface BroadcastSuppliersPanelProps {
  broadcastSuppliers: BroadcastSupplier[];
  onRemoveSupplier: (supplierId: string) => void;
  onClearAll: () => void;
  onSendBroadcastQuery: () => Promise<void>;
  isSending: boolean;
}

export const BroadcastSuppliersPanel: React.FC<
  BroadcastSuppliersPanelProps
> = ({
  broadcastSuppliers,
  onRemoveSupplier,
  onClearAll,
  onSendBroadcastQuery,
  isSending,
}) => {
  return (
    <Box
      borderColor="gray.200"
      overflowY="auto"
      zIndex={10}
      fontFamily="'Nunito','Inter', sans-serif"
      borderRadius="xl"
      ml={-4}
    >
      <VStack spacing={4} py={4} px={4} align="stretch">
        <Box
          bg="white"
          borderRadius="xl"
          p={4}
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
          fontFamily="'Nunito','Inter', sans-serif"
        >
          <Flex justify="space-between" align="center" mb={4}>
            <Text
              fontSize="1rem"
              fontWeight="bold"
              color="gray.800"
              fontFamily="'Nunito','Inter', sans-serif"
            >
              Broadcast List ({broadcastSuppliers.length})
            </Text>
            <IconButton
              aria-label="Clear all broadcast suppliers"
              icon={<MdDeleteForever size={20} />}
              size="sm"
              colorScheme="red"
              variant="ghost"
              onClick={onClearAll}
              isDisabled={isSending}
            />
          </Flex>

          <VStack
            spacing={4}
            align="stretch"
            maxH="27vh"
            overflowY="auto"
            width="100%"
            overflowX="hidden"
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "transparent",
              },
              "&:hover": {
                "&::-webkit-scrollbar-thumb": {
                  background: "#c1c1c1",
                  borderRadius: "3px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#a8a8a8",
                },
              },
            }}
          >
            {broadcastSuppliers.map((supplier, idx) => (
              <Box
                key={supplier.supplierId}
                bg="#F0F6FF"
                borderRadius="lg"
                p={4}
                position="relative"
              >
                <IconButton
                  aria-label="Remove supplier"
                  icon={<MdClose size="15" />}
                  variant="ghost"
                  colorScheme="red"
                  position="absolute"
                  top={1}
                  right={1}
                  size="2xs"
                  onClick={() => onRemoveSupplier(supplier.supplierId)}
                  _hover={{
                    bg: "transparent",
                  }}
                  isDisabled={isSending}
                />

                <VStack align="start" spacing={2} width="100%">
                  <Flex justify="space-between" align="center" width="100%">
                    <VStack align="start" spacing={0} flex={1}>
                      <Text
                        fontSize="0.875rem"
                        fontWeight="bold"
                        color="gray.800"
                        fontFamily="'Nunito','Inter', sans-serif"
                      >
                        {supplier.supplierName}
                      </Text>
                    </VStack>
                    <Badge
                      bg="transparent"
                      color="#3B82F6"
                      alignContent="right"
                      borderRadius="full"
                      fontSize="0.9rem"
                      fontWeight="bold"
                      fontFamily="'Nunito','Inter', sans-serif"
                    >
                      #{idx + 1}
                    </Badge>
                  </Flex>
                </VStack>
              </Box>
            ))}
          </VStack>

          <Button
            width="100%"
            colorScheme="whatsapp"
            leftIcon={<FaWhatsapp />}
            onClick={onSendBroadcastQuery}
            isLoading={isSending}
            loadingText="Sending..."
            isDisabled={broadcastSuppliers.length === 0}
            bg="#25D366"
            color="white"
            variant="solid"
            _hover={{ bg: "#1DA851" }}
            _active={{ bg: "#128C7E" }}
            fontFamily="'Nunito','Inter', sans-serif"
            fontSize="sm"
            size="sm"
            mt={2}
          >
            Broadcast Enquiry
          </Button>
        </Box>
      </VStack>
    </Box>
  );
};
